import React from 'react';
import { LifeGraphBasicFilter } from './LifeGraphBasicFilter';
import { LifeGraphAdvancedFilter } from './LifeGraphAdvancedFilter';
import { LifeGraphExplorerFilter } from '../lifegraph-explorer/lifegraph-explorer.types';
import { Dictionary } from 'lib';
import {
    AdvancedFormInputs,
    IFormInputs,
    FilterMode,
    formatQuery,
    stringWithEmptySpace,
} from './life-graph-filters-helpers';

interface LifeGraphFilterContainerProps {
    setFilter: (
        newFilter: LifeGraphExplorerFilter | string | undefined
    ) => void;
    filter: LifeGraphExplorerFilter | string | undefined;
    dictionaries: Dictionary[];
    filterMode: FilterMode;
    setFilterMode: React.Dispatch<React.SetStateAction<FilterMode>>;
    defaultQuery: AdvancedFormInputs;
    setDefaultQuery: React.Dispatch<React.SetStateAction<AdvancedFormInputs>>;
}

export const LifeGraphFilterContainer = ({
    setFilter,
    filter,
    dictionaries,
    filterMode,
    setFilterMode,
    defaultQuery,
    setDefaultQuery,
}: LifeGraphFilterContainerProps): React.JSX.Element => {
    const handleFilterModeChange = (
        mode: FilterMode,
        formData?: IFormInputs
    ): void => {
        if (mode === 'Advanced' && formData?.chain) {
            const query = `GRAPH ${formData.chain} ${
                formData.attributeKey &&
                formData.attributeValue &&
                !stringWithEmptySpace.test(formData.attributeValue) &&
                formData.attributeKey !== 'None'
                    ? `WHERE data.${formData.attributeKey} == ${formData.attributeValue}`
                    : ''
            } LIMIT ${formData.limit} TRAVERSE ANY 0..${formData.depth}`;
            setDefaultQuery({ query: formatQuery(query) });
        }
        setFilterMode(mode);
    };
    return (
        <>
            {filterMode === 'Basic' ? (
                <LifeGraphBasicFilter
                    setFilter={setFilter}
                    filter={typeof filter === 'string' ? undefined : filter}
                    dictionaries={dictionaries}
                    handleFilterModeChange={handleFilterModeChange}
                />
            ) : (
                <LifeGraphAdvancedFilter
                    setFilter={setFilter}
                    handleFilterModeChange={handleFilterModeChange}
                    defaultValues={defaultQuery}
                />
            )}
        </>
    );
};
